import { FunctionalComponent } from 'preact';

import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import tikTokSrc from './tiktok.svg';

// import { trackOutbound } from '../../../../../shared/analytics/outbound';

import styles from './styles.module.scss';

const TikTokIcon = () => <img src={tikTokSrc} alt="tiktok" />;

const SOCIAL_LIST = [
  ['https://www.instagram.com/oceanhero.today', InstagramIcon],
  ['https://www.facebook.com/Oceanhero.today', FacebookIcon],
  ['https://twitter.com/OceanheroToday', TwitterIcon],
  ['https://www.youtube.com/channel/UCqzXrRF25g4o_Pl7VnRhrGg', YouTubeIcon],
  ['https://www.tiktok.com/@oceanhero.today', TikTokIcon],
  ['https://www.linkedin.com/company/oceanhero', LinkedInIcon],
];

const LINKS = [
  ['https://about.oceanhero.today/about-us', 'Who we are'],
  ['https://about.oceanhero.today/our-mission', 'Our mission'],
  [
    'https://about.oceanhero.today/how-we-protect-your-privacy',
    'How we protect your privacy',
  ],
  ['https://marine-life.oceanhero.today', 'Encyclopedia'],
  ['https://about.oceanhero.today/certificates', 'Collection certificates'],
  process.env.APP_PLATFORM === 'web'
    ? null
    : [
      'https://www.about.oceanhero.today/bookmarks-extension',
      'How to show your bookmarks ⭐',
    ],
  [
    'https://docs.google.com/forms/d/e/1FAIpQLSfMMjcoSZ2ILlWmW_NPdPmdyj3cObcked3UyMnBMENK_Vsecg/viewform?usp=sf_link',
    'Share your opinion with us️',
  ],
].filter(Boolean);

const About: FunctionalComponent = () => {
  // const handleClick = (evt) => {
  //   trackOutbound([
  //     {
  //       variant: 'event',
  //       payload: ['Clicked ntp about link', { href: evt.target.href }],
  //     },
  //   ]);
  // };

  return (
    <div className={styles.container}>
      <a className={styles.navLink}>About</a>

      <div className={styles.popover}>
        <div className={styles.outerPopover}>
          <div className={styles.innerPopover}>
            {LINKS.map(([link, text]) => (
              <a
                // onClick={handleClick}
                className={styles.link}
                key={link}
                href={link}
              >
                {text}
              </a>
            ))}

            <footer className={styles.footer}>
              <p>Follow us on social media</p>

              <div>
                {SOCIAL_LIST.map(([link, Icon]) => (
                  <a
                    // onClick={handleClick}
                    key={link}
                    href={link as string}
                    className={styles.socialIcon}
                  >
                    <Icon />
                  </a>
                ))}
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
